const quantidadeValue = (asset) => {
  const quantidade = asset.quantidade
  if (
    quantidade === null ||
    quantidade === undefined ||
    String(quantidade).trim() === ''
  ) {
    return '-'
  }
  return quantidade
}

// Chave da coluna Classe ANBIMA. Nomeada porque três lugares dependem dela
// por igualdade de string: a config abaixo, a migração do switch legado e a
// migração de default (wallet-columns-preferences.js).
export const CLASSE_ANBIMA_COLUMN_KEY = 'classe_anbima'

export const WALLET_ASSET_COLUMN_CONFIG = [
  { key: 'ativo', label: 'Ativo', locked: true, defaultOn: true, cellType: 'custom' },
  { key: 'instituicao', label: 'Instituição', defaultOn: true, cellType: 'custom' },
  {
    key: 'portfolio',
    label: 'Portfólio',
    defaultOn: false,
    cellType: 'text',
    align: 'left',
    value: (asset) => asset.nome_portfolio || '-',
  },
  {
    key: 'quantidade',
    label: 'Quantidade',
    defaultOn: false,
    cellType: 'text',
    align: 'right',
    value: quantidadeValue,
  },
  {
    key: 'classe',
    label: 'Classe',
    defaultOn: false,
    cellType: 'text',
    align: 'left',
    value: (asset) => asset.classe || asset.CI || '-',
  },
  {
    key: 'subclasse',
    label: 'Subclasse',
    defaultOn: false,
    cellType: 'text',
    align: 'left',
    value: (asset) => asset.subclasse || '-',
  },
  {
    key: 'tipo',
    label: 'Tipo do ativo',
    defaultOn: false,
    cellType: 'text',
    align: 'left',
    value: (asset) => asset.Tipo || asset.tipo || '-',
  },
  { key: 'saldo_valor', label: 'Valor', group: 'Saldo Bruto', defaultOn: true, cellType: 'custom' },
  { key: 'saldo_pct', label: '%', group: 'Saldo Bruto', defaultOn: true, cellType: 'custom' },
  { key: 'saldo_data', label: 'Data', group: 'Saldo Bruto', defaultOn: true, cellType: 'custom' },
  {
    key: 'rent_valor',
    label: 'Rendimento',
    group: 'Rentabilidade',
    defaultOn: true,
    cellType: 'custom',
  },
  {
    key: 'rent_inicio',
    label: 'Início',
    group: 'Rentabilidade',
    defaultOn: true,
    cellType: 'custom',
  },
  { key: 'rent_data', label: 'Data', group: 'Rentabilidade', defaultOn: true, cellType: 'custom' },
  { key: 'volatilidade', label: 'Volatilidade', defaultOn: true, cellType: 'custom' },
  { key: 'recomendacao', label: 'Recomendação', defaultOn: false, cellType: 'custom' },
  { key: 'comentario', label: 'Comentário', defaultOn: true, cellType: 'custom' },
  {
    key: CLASSE_ANBIMA_COLUMN_KEY,
    label: 'Classe ANBIMA',
    defaultOn: true,
    cellType: 'text',
    align: 'center',
    cellClass: 'az-text-primary az-size-12',
    value: (asset) => asset.classe_anbima || '',
  },
  { key: 'acoes', label: 'Ações', locked: true, defaultOn: true, cellType: 'custom' },
]

const columnsInGroup = (group) =>
  WALLET_ASSET_COLUMN_CONFIG.filter((column) => column.group === group).map(
    (column) => column.key
  )

export const ALL_TOGGLEABLE_COLUMN_KEYS = WALLET_ASSET_COLUMN_CONFIG.map(
  (column) => column.key
)

export const DEFAULT_VISIBLE_COLUMN_KEYS = WALLET_ASSET_COLUMN_CONFIG.filter(
  (column) => column.defaultOn
).map((column) => column.key)

export const LOCKED_COLUMN_KEYS = WALLET_ASSET_COLUMN_CONFIG.filter(
  (column) => column.locked
).map((column) => column.key)

export const SALDO_BRUTO_COLUMNS = columnsInGroup('Saldo Bruto')
export const RENTABILIDADE_COLUMNS = columnsInGroup('Rentabilidade')

export const LEAF_COLUMN_LABEL_TO_KEY = WALLET_ASSET_COLUMN_CONFIG.filter(
  (column) => !column.group
).reduce((map, column) => {
  map[column.label] = column.key
  return map
}, {})

// Agrupa as colunas em unidades de RENDER (coluna solta ou cabecalho de grupo
// com N filhas). Funcao pura do catalogo, exportada porque quem injeta um
// catalogo proprio (ex: a carteira do grupo, que acrescenta `membro`) precisa
// das unidades DERIVADAS dele, nao das do catalogo do cliente.
export const buildRenderUnits = (config) =>
  (Array.isArray(config) ? config : []).reduce(
  (units, column) => {
    if (!column.group) {
      units.push({ kind: 'single', key: column.key, column })
      return units
    }
    const last = units.at(-1)
    if (last && last.kind === 'group' && last.group === column.group) {
      last.columns.push(column)
      return units
    }
    units.push({
      kind: 'group',
      group: column.group,
      columns: [column],
    })
    return units
  },
  []
)

export const WALLET_ASSET_RENDER_UNITS = buildRenderUnits(
  WALLET_ASSET_COLUMN_CONFIG
)

// Estrutura do SELETOR de colunas. Pura sobre o catalogo, exportada pelo mesmo
// motivo do `buildRenderUnits`: quem injeta catalogo proprio precisa do seletor
// enxergando as colunas DELE. Se o seletor nao conhece uma coluna, o `input` que
// ele emite na montagem devolve a lista SEM ela e apaga a coluna da preferencia.
export const buildColumnGroups = (config) =>
  (Array.isArray(config) ? config : []).reduce(
  (groups, column) => {
    if (!column.group) {
      groups[column.label] = {}
      return groups
    }
    if (!groups[column.group]) groups[column.group] = {}
    groups[column.group][column.key] = column.label
    return groups
  },
  {}
)

export const ASSET_COLUMN_GROUPS = buildColumnGroups(WALLET_ASSET_COLUMN_CONFIG)
